import AppHeader from "@/components/AppHeader";
import dayjs from "dayjs";

export default {
  name: "csv-tkc",
  components: {
    AppHeader,
  },
  async created() {
    this.getCompany();
    await this.getTargetDate();
  },
  data() {
    return {
      companies: "",
      users: [],
      selectedCompany: localStorage.company_id,
      selectedMonth: "",
      targetDates: [],
      getCompanisEnd: false,
      searchEnd: false,
      attendances: [],
    };
  },
  methods: {
    async getCompany() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY", { data: data })
        .catch((err) => {
          console.log(err);
          return;
        });
      this.companies = res.companies;
      this.getCompanisEnd = true;
    },
    getTargetDate() {
      if (this.selectedCompany == 1) {
        let targetYyyyMm = dayjs("2020-04").format("YYYY-MM");
        let endYyyyMm = dayjs().format("YYYY-MM");
        for (;;) {
          if (targetYyyyMm > endYyyyMm) break;
          this.targetDates.unshift({
            text: dayjs(targetYyyyMm).format("YYYY年MM月"),
            value: dayjs(targetYyyyMm).format("YYYY-MM"),
          });
          this.selectedMonth = dayjs(targetYyyyMm).format("YYYY-MM");
          targetYyyyMm = dayjs(targetYyyyMm)
            .add(1, "month")
            .format("YYYY-MM");
        }
      } else {
        let today = new Date();
        let targetYyyyMm = dayjs("2020-04").format("YYYY-MM");
        let endYyyyMm = dayjs().format("YYYY-MM");
        if (today.getDate() >= 16) {
          endYyyyMm = dayjs()
            .add(1, "month")
            .format("YYYY-MM");
        }
        for (;;) {
          if (targetYyyyMm > endYyyyMm) break;
          this.targetDates.unshift({
            text: dayjs(targetYyyyMm).format("YYYY年MM月"),
            value: dayjs(targetYyyyMm).format("YYYY-MM"),
          });
          this.selectedMonth = dayjs(targetYyyyMm).format("YYYY-MM");
          targetYyyyMm = dayjs(targetYyyyMm)
            .add(1, "month")
            .format("YYYY-MM");
        }
      }
    },
    async csvDownload() {
      let data = {
        company_id: this.selectedCompany,
        target_month: this.selectedMonth,
      };
      let res = await this.$store
        .dispatch("GET_TKC_CSV", { data: data })
        .catch((err) => {
          console.log(err);
          return;
        });
      this.downloadCsv(res.attendances);
    },
    downloadCsv: function(data) {
      let wkFileName = "TKC勤怠" + this.selectedMonth + "分.csv";
      const csvFileName = wkFileName;
      let bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      let mimeType = "text/csv";
      let csv =
        "社員番号,社員氏名,平日出勤,出勤時間,有休日数,その他の休日,控除日数,時間外手当時間B,時間外手当時間C,時間外手当時間D,時間外手当時間E,時間外手当時間F\n";
      data.forEach((obj) => {
        if (obj.tkc_user_no) {
          csv += this.enquoteForCSV(obj.tkc_user_no) + ",";
        } else {
          csv += "0,";
        }
        if (obj.user_name) {
          csv += this.enquoteForCSV(obj.user_name) + ",";
        } else {
          csv += ",";
        }
        if (obj.syukkin_nissu) {
          csv += this.enquoteForCSV(obj.syukkin_nissu) + ",";
        } else {
          csv += "0,";
        }
        // 出勤時間は空
        csv += ",";

        if (obj.yukyu_nissu_kei) {
          csv += this.enquoteForCSV(obj.yukyu_nissu_kei) + ",";
        } else {
          csv += "0,";
        }
        if (obj.tokkyu && obj.furikyu) {
          csv += this.enquoteForCSV(obj.tokkyu + obj.furikyu) + ",";
        } else {
          csv += "0,";
        }
        // 控除日数は空
        csv += ",";
        if (obj.heijitu_zangyo) {
          csv += this.enquoteForCSV(obj.heijitu_zangyo) + ",";
        } else {
          csv += "0,";
        }
        if (obj.heijitu_shinya) {
          csv += this.enquoteForCSV(obj.heijitu_shinya) + ",";
        } else {
          csv += "0,";
        }
        if (obj.kyujitu_zangyo) {
          csv += this.enquoteForCSV(obj.kyujitu_zangyo) + ",";
        } else {
          csv += "0,";
        }
        if (obj.kyujitu_shinya) {
          csv += this.enquoteForCSV(obj.kyujitu_shinya) + ",";
        } else {
          csv += "0,";
        }
        if (obj.syoteinai_shinya) {
          csv += this.enquoteForCSV(obj.syoteinai_shinya);
        } else {
          csv += "0";
        }
        csv += "\n";
      });
      const blob = new Blob([bom, csv], { type: mimeType });
      let hiddenElement = document.createElement("a");
      hiddenElement.download = csvFileName;
      hiddenElement.target = "_blank";
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, csvFileName);
      } else if (window.URL && window.URL.createObjectURL) {
        hiddenElement.href = window.URL.createObjectURL(blob);
        document.body.appendChild(hiddenElement);
        hiddenElement.click();
        document.body.removeChild(hiddenElement);
      } else if (window.webkitURL && window.webkitURL.createObject) {
        hiddenElement.href = (window.URL || window.webkitURL).createObjectURL(
          blob
        );
        hiddenElement.click();
      }
    },
    enquoteForCSV: function(val) {
      if (!val) return val;
      if (/[",\r\n]/.test(val)) {
        //",\r\nが含まれる場合はenquoteする
        val = '"' + val.replace(/"/g, '""') + '"';
      }
      return val;
    },
  },
};
